import {
  aFetchDirectDebitBankAccounts,
  selectDirectDebitBankAccountsWhereLoaded,
} from '../../../data/direct-debit-account'

import {AppThunkAction} from '../../../types/redux'

export const selectDirectDebitBankAccountsArePending = (state: Record<string, any>): boolean =>
  !selectDirectDebitBankAccountsWhereLoaded(state)

export const aInitializeDirectDebitBankAccounts =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchDirectDebitBankAccounts())
  }
